/**
 * masthead 프리뷰를 **켤지 말지** (v32 · `docs/63` §5.4).
 *
 * 셋 중 하나만 걸려도 거짓이다. **자동재생 정책은 묻지 않는다** — `navigator.getAutoplayPolicy`
 * 는 Chrome 에 없다(`auto-start.ts` 가 그래서 버렸다). `play()` 를 부르고 거절을 받는 것이
 * 정책 쪽의 판정이고 그것은 `use-home-preview.ts` 에 있다.
 *
 * 순수 함수다 — 사실을 읽는 자리(`readAppDisplay()` · `navigator.connection` · 저장소)와 가른다.
 */
export interface PreviewEnv {
  /** `readAppDisplay().handheld` 또는 `clientType === 'mobile_web'` — 모바일은 포스터만 */
  readonly handheld: boolean;
  /** `navigator.connection?.saveData ?? false` */
  readonly saveData: boolean;
  /** 설정 시트의 「홈에서 미리보기」 (`bloom.homePreview` · 기본 켬) */
  readonly userEnabled: boolean;
}

export function previewAllowed(env: PreviewEnv): boolean {
  return !env.handheld && !env.saveData && env.userEnabled;
}
